export const TABLE_GAME_MENUS = [
  {
    _id: '63c11211b64f6450d162f709',
    component_content_id: '63806cad40b4a5aea422f097',
    title: {
      'en-US': 'All bet blackjack',
      'th-TH': 'All bet blackjack',
      'zh-CN': 'Flowgaming'
    },
    description: {
      'en-US': 'All bet blackjack',
      'th-TH': 'All bet blackjack',
      'zh-CN': 'Flowgaming'
    },
    is_visible: true,
    is_active: true,
    link_type: 1,
    game_id: 5111,
    game_provider_id: 53,
    sequence: 4,
    image_desktop_path: {
      'en-US': 'demo/games/table/image-1-en.png',
      'th-TH': 'demo/games/table/image-1-th.png',
      'zh-CN': 'demo/games/table/image-1-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/table/image-1-en-mobile.png',
      'th-TH': 'demo/games/table/image-1-th-mobile.png',
      'zh-CN': 'demo/games/table/image-1-ch-mobile.png'
    },
    __v: 0,
    created_at: '2023-01-13T08:10:57.528Z',
    updated_at: '2024-12-29T07:55:43.532Z',
    image_path: {
      'en-US': null,
      'th-TH': null
    },
    link: {
      'en-US': null,
      'th-TH': null,
      'vi-VN': null,
      'zh-CN': null
    }
  },
  {
    _id: '63c11a4bb64f6450d162f7c0',
    component_content_id: '63806cad40b4a5aea422f097',
    title: {
      'en-US': 'Viking',
      'th-TH': 'Viking',
      'zh-CN': 'Playtech'
    },
    description: {
      'en-US': 'Viking',
      'th-TH': 'Viking',
      'zh-CN': 'Playtech'
    },
    is_visible: true,
    is_active: true,
    link_type: 1,
    game_id: 5128,
    game_provider_id: 53,
    sequence: 5,
    image_desktop_path: {
      'en-US': 'demo/games/table/image-2-en.png',
      'th-TH': 'demo/games/table/image-2-th.png',
      'zh-CN': 'demo/games/table/image-2-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/table/image-2-en-mobile.png',
      'th-TH': 'demo/games/table/image-2-th-mobile.png',
      'zh-CN': 'demo/games/table/image-2-ch-mobile.png'
    },
    __v: 0,
    created_at: '2023-01-13T08:46:04.016Z',
    updated_at: '2024-12-29T07:55:43.630Z',
    image_path: {
      'en-US': null,
      'th-TH': null
    },
    link: {
      'en-US': null,
      'th-TH': null,
      'vi-VN': null,
      'zh-CN': null
    }
  },
  {
    _id: '63c108fab64f6450d162f654',
    component_content_id: '63806cad40b4a5aea422f097',
    title: {
      'en-US': 'Royal Sic bo',
      'th-TH': 'Royal Sic bo',
      'zh-CN': 'SBO'
    },
    description: {
      'en-US': 'Royal Sic bo',
      'th-TH': 'Royal Sic bo',
      'zh-CN': 'SBO'
    },
    is_visible: true,
    is_active: true,
    link_type: 1,
    game_id: 5097,
    game_provider_id: 53,
    sequence: 2,
    image_desktop_path: {
      'en-US': 'demo/games/table/image-3-en.png',
      'th-TH': 'demo/games/table/image-3-th.png',
      'zh-CN': 'demo/games/table/image-3-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/table/image-3-en-mobile.png',
      'th-TH': 'demo/games/table/image-3-th-mobile.png',
      'zh-CN': 'demo/games/table/image-3-ch-mobile.png'
    },
    __v: 0,
    created_at: '2023-01-13T07:32:10.847Z',
    updated_at: '2024-12-29T07:55:43.430Z',
    image_path: {
      'en-US': null,
      'th-TH': null
    },
    link: {
      'en-US': null,
      'th-TH': null,
      'vi-VN': null,
      'zh-CN': null
    }
  },
  {
    _id: '63c11211b64f6450d162f707',
    component_content_id: '63806cad40b4a5aea422f097',
    title: {
      'en-US': '101 roulette ',
      'th-TH': '101 roulette ',
      'zh-CN': 'King maker'
    },
    description: {
      'en-US': '101 roulette ',
      'th-TH': '101 roulette ',
      'zh-CN': 'King maker'
    },
    is_visible: true,
    is_active: true,
    link_type: 1,
    game_id: 0,
    game_provider_id: 26,
    sequence: 3,
    image_desktop_path: {
      'en-US': 'demo/games/table/image-4-en.png',
      'th-TH': 'demo/games/table/image-4-th.png',
      'zh-CN': 'demo/games/table/image-4-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/table/image-4-en-mobile.png',
      'th-TH': 'demo/games/table/image-4-th-mobile.png',
      'zh-CN': 'demo/games/table/image-4-ch-mobile.png'
    },
    __v: 0,
    created_at: '2023-01-13T08:10:57.527Z',
    updated_at: '2024-12-29T07:55:43.436Z',
    image_path: {
      'en-US': null,
      'th-TH': null
    },
    link: {
      'en-US': null,
      'th-TH': null,
      'vi-VN': null,
      'zh-CN': null
    }
  },
  {
    _id: '63c108fab64f6450d162f658',
    component_content_id: '63806cad40b4a5aea422f097',
    title: {
      'en-US': 'Money roll',
      'th-TH': 'Money roll',
      'zh-CN': 'World match'
    },
    description: {
      'en-US': 'Money roll',
      'th-TH': 'Money roll',
      'zh-CN': 'World match'
    },
    is_visible: true,
    is_active: true,
    link_type: 1,
    game_id: 9121,
    game_provider_id: 101,
    sequence: 6,
    image_desktop_path: {
      'en-US': 'demo/games/table/image-5-en.png',
      'th-TH': 'demo/games/table/image-5-th.png',
      'zh-CN': 'demo/games/table/image-5-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/table/image-5-en-mobile.png',
      'th-TH': 'demo/games/table/image-5-th-mobile.png',
      'zh-CN': 'demo/games/table/image-5-ch-mobile.png'
    },
    __v: 0,
    created_at: '2023-01-13T07:32:10.848Z',
    updated_at: '2024-12-29T07:55:43.635Z',
    image_path: {
      'en-US': null,
      'th-TH': null
    },
    link: {
      'en-US': null,
      'th-TH': null,
      'vi-VN': null,
      'zh-CN': null
    }
  }
]
